<template>
  <div class="toobar-menu overflow-x">
    <div>
      <v-container>
        <v-row>
          <v-flex xs9 sm10 md10 lg11 xl11 class="container">
            <div class="py-3">
              <v-img class="logo-newpartner" src="img/rsl/saleforec.png" />
            </div>
          </v-flex>
          <v-flex
            xs3
            sm2
            md2
            lg1
            xl1
            class="container cursor-pointer icon-hamberger"
          >
            <div class @click="$emit('openmenu')">
              <v-icon class="icon-font-45-nav btn-menu-home">icon-Menu</v-icon>
            </div>
          </v-flex>
        </v-row>

        <div class="card-profile">
          <div class="profile">
            <img :src="user.profile" />
            <div class="username">
              <span class="f-20 text-black font-w-500">{{ user.name }}</span>
              <span class="f-20 font-w-500 text-red-d">{{
                user.position
              }}</span>
            </div>
          </div>
          <div class="shadow-profile"></div>
          <div class="shadow-profile2"></div>
        </div>

        <div
          v-if="visitCustomer != null"
          class="card-visit"
          @click="linkTo('checkinout')"
        >
          <div class="blog-visit">
            <div class="d-flex">
              <img src="img/icons_v2/icon_people.png" />
              <div class="pl-4">
                <span>กำลังเข้าเยี่ยม</span>
                <h2>{{ visitCustomer.customer_name }}</h2>
              </div>
            </div>
            <i class="icon-RIGHT f-45"></i>
          </div>
        </div>

        <div class="card-tools">
          <div class="d-flex justify-content-between">
            <div class="blog-square" @click="linkTo('stock')">
              <v-icon class="f-70">icon-SKUTRANS</v-icon>
              <span class="f-20 font-w-500">เก็บราคา</span>
            </div>
            <div class="blog-square" @click="linkTo('calendar')">
              <v-icon class="f-70">icon-M05</v-icon>
              <span class="f-20 font-w-500">ตารางเข้าเยี่ยม</span>
            </div>
          </div>

          <div class="d-flex justify-content-between">
            <div class="blog-square" @click="linkTo('listdata')">
              <v-icon class="f-70">icon-HISTORY-Copy-9</v-icon>
              <span class="f-20 font-w-500">บันทึกโน๊ต</span>
            </div>
            <div
              v-if="visitCustomer == null"
              class="blog-square"
              @click="linkTo('checkinout')"
            >
              <v-icon class="f-70">icon-Pin</v-icon>
              <span class="f-20 font-w-500">เช็คอิน</span>
            </div>
            <div v-else class="blog-square" @click="onCheckOut()">
              <v-icon class="f-70">icon-Pin</v-icon>
              <span class="f-20 font-w-500">เช็คเอาท์</span>
            </div>
          </div>

          <div class="d-flex justify-content-between">
            <div class="blog-square" @click="linkPrompt('sales-order')">
              <v-icon class="f-70">icon-BASKET</v-icon>
              <span class="f-20 font-w-500">เสนอราคา</span>
            </div>
            <div class="blog-square" @click="linkPrompt('quotations')">
              <v-icon class="f-70">icon-Billing2</v-icon>
              <span class="f-20 font-w-500">ใบเสนอราคาทั้งหมด</span>
            </div>
          </div>

          <div class="d-flex justify-content-between">
            <div class="blog-square" @click="linkPrompt('customer')">
              <img src="img/icons/promotion.png" height="60px" alt="" />
              <span class="f-20 font-w-500">โปรโมชั่นรายเดือน</span>
            </div>
            <div class="blog-square" @click="linkTo('todo-list')">
              <i class="rd-file-down-dash f-70" style="color: #aa0c1e"></i>
              <span class="f-20 font-w-500">งานมอบหมาย</span>
            </div>
          </div>

          <div class="d-flex justify-content-between">
            <div class="blog-square" @click="linkTo('collect-target-price')">
              <i class="rd-product-coin f-70" style="color: #aa0c1e"></i>
              <span class="f-20 font-w-500">เก็บราคาตามเป้าหมาย</span>
            </div>
          </div>
        </div>

        <div class="card-slider">
          <v-carousel
            cycle
            height="auto"
            hide-delimiter-background
            show-arrows-on-hover
            interval="5000"
            :next-icon="false"
            :prev-icon="false"
            hide-delimiters
          />
        </div>
      </v-container>
    </div>

    <DialogConfirmInOut
      :dialog="dialogConfirm"
      :item="visitCustomer"
      :status="false"
      @close="dialogConfirm = false"
      @save="saveCheck"
    />
  </div>
</template>

<script>
import DialogConfirmInOut from '@/components/v2/checkinout/DialogConfirmInOut'
import { mapState, mapGetters, mapActions } from 'vuex'
export default {
  components: {
    DialogConfirmInOut,
  },

  computed: {
    ...mapState({
      user: (state) => state.auth.user,
      shop: (state) => state.auth.shop,
      location: (state) => state.checkinout.location,
    }),

    ...mapGetters({
      newAccessToken: ['auth/getAccessToken'],
    }),

    checkLinkCustomer() {
      const host = window.location.hostname
      return host == 'newpartner.scg.com' ? true : false
    },
  },

  data() {
    return {
      notification: null,
      visitCustomer: null,
      dialogConfirm: false,
    }
  },

  methods: {
    ...mapActions({
      visitCustomers: 'checkinout/visitCustomers',
    }),

    getNotificationVisit() {
      const formData = {
        user_id: this.user.id,
        shop_id: this.shop.id,
      }
      const options = {
        url: `${this.$baseAPINew}/web/?act=noti_visit_customer`,
        method: 'POST',
        data: formData,
      }
      this.$axios(options).then((res) => {
        this.notification = res.data
      })
    },

    saveCheck(item) {
      const customerId = item.customer_id

      const formData = {
        user_id: this.user.id,
        customer_id: customerId,
        lat_lng: this.location,
      }

      const options = {
        url: `${this.$baseAPINew}/web/?act=check_in_out_web`,
        method: 'POST',
        data: formData,
      }

      this.$axios(options)
        .then((result) => {
          console.log(result)
          const res = result.data
          if (res.status == 200) {
            Swal.fire({
              icon: 'success',
              title: `${res.message}`,
              showConfirmButton: false,
              timer: 1500,
            })

            this.dialogConfirm = false
            setTimeout(() => {
              window.location.reload()
            }, 500)
          } else {
            Swal.fire({
              icon: 'warning',
              title: `${res.message}`,
              showConfirmButton: false,
              timer: 1500,
            })
          }
        })
        .catch((err) => {
          Swal.fire({
            icon: 'warning',
            title: `เกิดข้อผิดพลาด กรุณาโหลดหน้าใหม่`,
            showConfirmButton: false,
            timer: 1000,
          })
          console.warn(err)
        })
    },

    onCheckOut() {
      this.dialogConfirm = true
    },

    linkTo(path) {
      this.$router.push(path)
    },

    removeParameterURL() {
      const url = new URL(location)
      url.searchParams.delete('token')
      history.replaceState(null, null, url)
    },

    linkPrompt(state) {
      const host = window.location.hostname
      const token = this.$store.getters['auth/getAuthToken']

      var refURL = ''
      var keyURL = `/rudy/signin?refToken=${token}&redirectUri=`
      if (state == 'customer') {
        refURL = `${keyURL}/bp-dummy/create`
      } else if (state == 'sales-order') {
        refURL = `${keyURL}/sales-order?qt=true`
      } else if (state == 'quotations') {
        refURL = `${keyURL}/quotations`
      }

      const checkURL =
        host == 'newpartner.scg.com'
          ? `${process.env.VUE_APP_URL_PROMPT_PROD}${refURL}`
          : `${process.env.VUE_APP_URL_PROMPT_TEST}${refURL}`

      window.open(checkURL)
    },
  },

  mounted() {
    this.removeParameterURL()
    this.visitCustomers({ user_id: this.user.id }).then((result) => {
      this.visitCustomer = result.length === 0 ? null : result
    })
  },
}
</script>

<style lang="scss" scoped>
.toobar-menu {
  background-image: url('../../public/img/rsl/bk-newpartner.png');
  background-size: cover;
  height: 100vh;
}
.icon-hamberger {
  display: flex;
  align-items: center;
  justify-content: flex-end;
}
.card-profile {
  position: relative;
  margin: 50px 0px 9vh 0px;
  background: white;
  border-radius: 15px;
  box-shadow: 3px 8px 10px 0 rgb(0 0 0 / 5%);
  z-index: 10;

  & .profile {
    display: flex;
    align-items: center;
    padding: 10px 30px;
    height: 150px;

    & img {
      border-radius: 50%;
      width: 100px;
      height: 100px;
    }
    & .username {
      display: flex;
      flex-direction: column;
      margin-left: 25px;
    }
  }
}
.card-tools {
  // width: 112%;
  // margin-left: -53px;
  background: #878787;
  // position: absolute;
  // left: 0;
  // width: 100%;
  height: auto;
  padding: 60px 30px;
  border-top-right-radius: 15px;
  border-top-left-radius: 15px;
}
.blog-square {
  cursor: pointer;
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  background: white;
  border-radius: 10px;
  width: 100%;
  margin: 15px;
  height: 170px;
  box-shadow: 3px 8px 10px 0 rgba(0, 0, 0, 0.12);
  &.horizontal {
    flex-direction: unset;
    height: 100px;
  }
}

.blog-2 {
  flex-direction: unset !important;
  height: 120px !important;
}

.card-slider {
  width: 112%;
  margin-left: -50px;
}

.f {
  &-20 {
    font-size: 20px;
  }
  &-30 {
    font-size: 30px;
  }
  &-40 {
    font-size: 40px;
  }
  &-50 {
    font-size: 50px;
  }
  &-60 {
    font-size: 60px;
  }
  &-70 {
    font-size: 60px;
  }
}

.icon-notification {
  width: 45px;
  height: 45px;
  top: -20px;
  right: -15px;
  display: flex;
  align-items: center;
  justify-content: center;
  position: absolute;
  border-radius: 50%;
  background: red;
  z-index: 50;
  color: white;
  box-shadow: 0 2px 10px 0 rgb(248 27 27 / 73%);
}

.logo-newpartner {
  width: 350px;
  height: auto;
}

.icon-Menu:before {
  color: #a1a0a0 !important;
}

.shadow-profile {
  position: absolute;
  background: #f7f6f6;
  width: 90%;
  height: 20px;
  left: 40px;
  border-bottom-right-radius: 20px;
  border-bottom-left-radius: 20px;
  box-shadow: 3px 8px 10px 0 rgb(0 0 0 / 3%);
}
.shadow-profile2 {
  position: absolute;
  background: #f0f0f0;
  width: 82%;
  height: 20px;
  left: 73px;
  border-bottom-right-radius: 20px;
  border-bottom-left-radius: 20px;
  box-shadow: 3px 8px 10px 0 rgb(0 0 0 / 3%);
  bottom: -40px;
}

.card-visit {
  width: 100%;
  // margin-left: -53px;
  background: #ffebdb;
  border: 2px solid #ffa572;
  left: 0;
  height: auto;
  padding: 40px 30px;
  border-top-right-radius: 15px;
  border-top-left-radius: 15px;
  margin-bottom: -15px;
}

.blog-visit {
  display: flex;
  justify-content: space-between;

  & i {
    display: flex;
    align-items: center;
  }

  & span {
    color: #ce6500;
  }
}

.btn-disabled {
  background-color: #c8c8c8;
}
</style>
